import React, { FC, useEffect, useMemo, useState, memo } from 'react'
import { IonSlides, IonSlide } from '@ionic/react'
import { ProductImage } from '@cps'
import './index.scss'

interface IProps {
  imgUrl: string;
  pics: string;
  imgStyle: {
    width: number;
    height: number;
  };
  onClick?: () => void;
}

const DetailTop: FC<IProps> = ({ imgStyle, imgUrl, onClick, pics }) => {
  const [imgArr, setImgArr] = useState([])
  const [isLoading, setLoading] = useState(true)

  const slideOpts = useMemo(() => {
    return {
      initialSlide: 0,
      speed: 300,
      autoplay: imgArr[0]?.type === 'video' ? false : { disableOnInteraction: false },
    }
  }, [])

  useEffect(() => {
    setLoading(false)
  }, [imgArr])

  useEffect(() => {
    setLoading(true)
    let _imgArr = []
    try {
      _imgArr = pics ? JSON.parse(pics).filter(item => !!item) : []
    } catch (error) {}
    if (_imgArr.length && _imgArr[0].type === 'video') {
      let videoDOM = document.getElementById('mall_video_only')
      if (_imgArr.length > 1) {
        videoDOM = document.getElementById('video_0')
      }
      if (videoDOM) {
        (videoDOM as any).play()
      }
    }
    // 防止商品详情内跳转，图片更换造成ionSlider报错，需要重新加载ionSlider，ionSlider不能动态更新图片？
    setTimeout(() => {
      setImgArr(_imgArr)
    }, 10)
  }, [pics])

  const handleVideoEndCallBack = () => {
    const swiperDOM = (document.getElementById(`advertElement${imgUrl}`) as any)
    if (swiperDOM && swiperDOM.swiper) {
      swiperDOM.swiper.autoplay.start()
    }
  }
  return (
    <div className='detail-top' onClick={onClick}>
      <div className='detail-image'>
        {
          !isLoading ? (
            imgArr.length === 1 || (!imgArr.length && imgUrl) ? (
              <div style={{ ...imgStyle }}>
                {
                  ['image', 'product'].includes(imgArr[0]?.type) || (!imgArr.length && imgUrl) ? (
                    <ProductImage type='mall' width={imgStyle.width} height={imgStyle.height} imgSrc={imgArr[0]?.url || ''} />
                  ) : (
                    <div className='item-resource'>
                      <div className='video-bg' style={{ backgroundImage: `url(${imgArr[0].videoImageUrl})` }}></div>
                      <video
                        src={imgArr[0]?.url}
                        id='mall_video_only'
                        style={{ maxWidth: '100%', maxHeight: '100%' }}
                        controls
                        muted
                        playsInline
                        webkit-playsinline='true'
                        // autoPlay
                      />
                    </div>
                  )
                }
              </div>
            ) : (
              <IonSlides
                id={`advertElement${imgUrl}`}
                className='slide-list'
                options={slideOpts}
                onIonSlideDidChange={() => {
                  const swiperDOM = (document.getElementById(`advertElement${imgUrl}`) as any)
                  imgArr.forEach((item, index) => {
                    if (item.type === 'video') {
                      const videoDOM = document.getElementById(`video_${index}`)
                      if (videoDOM) {
                        (videoDOM as any).pause()
                      }
                    }
                  })
                  if (swiperDOM && swiperDOM.swiper) {
                    // swiperDOM.swiper.autoplay.start()
                    // setActiveIndex(swiperDOM.swiper.realIndex + 1)
                    if (imgArr[swiperDOM.swiper.realIndex]?.type === 'video') {
                      swiperDOM.swiper.autoplay.stop()
                      const videoDOM = document.getElementById(`video_${swiperDOM.swiper.realIndex}`)
                      if (videoDOM) {
                        (videoDOM as any).play()
                      }
                    } else {
                      swiperDOM.swiper.autoplay.start()
                    }
                  }
                }}
                style={{ ...imgStyle }}
              >
                {
                  imgArr.map((item, index) => (
                    <IonSlide
                      key={index}
                      className='slide-item'
                    >
                      {
                        ['image', 'product'].includes(item.type) ? (
                          <div
                            className='slide-item-resource'
                            key={`${item.type}_${item.url}`}
                            style={{
                              // ...itemStyle,
                              width: imgStyle.width,
                              height: imgStyle.height,
                              backgroundImage: `url(${item.url})`
                            }}
                          />
                        ) : (
                          <div className='slide-item-resource'>
                            <div className='video-bg' style={{ backgroundImage: `url(${item.videoImageUrl})` }}>
                            </div>
                            <video
                              id={`video_${index}`}
                              src={item.url}
                              style={{ maxWidth: '100%', maxHeight: '100%' }}
                              controls
                              muted
                              playsInline
                              webkit-playsinline='true'
                              onEnded={handleVideoEndCallBack}
                            />
                          </div>
                        )
                      }
                      <div
                        className='slide-item-pagination'
                      >
                        <span>{index + 1}</span>/{imgArr.length}
                      </div>
                    </IonSlide>
                  ))
                }
              </IonSlides>
            )
          ) : null
        }
      </div>
    </div>
  )
}

export default memo(DetailTop)
